import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'nova-delegation-empty-card',
    standalone: true,
    imports: [MatIconModule],
    templateUrl: './delegation-empty-card.component.html',
    styleUrls: ['./delegation-empty-card.component.scss']
})
export class DelegationEmptyCardComponent {
    constructor() {}
}
